<template>
  <v-chip label :color="getColorExpectedDate()">
    {{ addBusinessDays(date, offset) }}
    <!-- <sup>
      <i>({{ offset }})</i>
    </sup> -->
  </v-chip>
</template>

<script>
import { addBusinessDays, formatStringData, checkDateLess, checkDateGreater } from '@/plugins/generic.js'

export default {
  props: {
    date: String,
    offset: String,
    delivery: {
      type: String,
      default: null,
    },
  },
  methods: {
    addBusinessDays,
    checkDateLess,
    checkDateGreater,
    formatStringData,
    getColorExpectedDate() {
      const expectDate = this.formatStringData(addBusinessDays(this.date, this.offset))
      if (this.delivery) {
        return 'white'
      }
      if (this.checkDateGreater(expectDate, 2)) {
        return 'white'
      } else if (this.checkDateLess(expectDate, 2) && this.checkDateGreater(expectDate, 0)) {
        return 'amber lighten-2'
      } else {
        return 'red lighten-1'
      }
    },
    removeBd() {
      return parseInt(this.offset)
    },
  },
}
</script>

<style></style>
